// Safe access to environment variables
const env = typeof process !== 'undefined' && process.env ? process.env : {};

const config = {
  apiBaseUrl: env.REACT_APP_API_URL || 'https://api.rekxup.com',
  env: env.NODE_ENV || 'development',
  firebase: {
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.REACT_APP_FIREBASE_APP_ID,
    measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID
  },
  uploadLimits: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedFileTypes: ['csv', 'xlsx', 'xls'],
  },
};

// Only validate environment variables if process is defined
if (typeof process !== 'undefined' && process.env) {
  const requiredEnvVars = [
    'REACT_APP_API_URL',
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID',
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    'REACT_APP_FIREBASE_APP_ID',
    'REACT_APP_FIREBASE_MEASUREMENT_ID'
  ];

  requiredEnvVars.forEach(varName => {
    if (!process.env[varName]) {
      console.warn(`Missing environment variable: ${varName}`);
    }
  });
}

export default config;